const plLocaleData = require("i18next-icu/locale-data/pl");
export default plLocaleData;
